import api from "../../util/api";

export const toggleBadge = (videoId, badge) => {
    return api.put(`v2/api/review/${videoId}/feature/${badge.id}/${badge.person_id}/toggle`, {}).then(({data}) => {
        return data;
    });
    // .catch((err) => );
};

export const toggleDeletePerson = (videoId, personId) => {
    return api.put(`v2/api/review/${videoId}/speaker/${personId}/toggle`, {}).then(({data}) => {
        return data;
    });
    // .catch((err) => );
};

export const editPerson = (videoId, personId, personData) => {
    return api
        .put(
            `v2/api/review/${videoId}/speaker/${personId}`,
            {...personData},
            {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json; charset=utf-8",
                },
            }
        )
        .then(({data}) => {
            return data;
        });
    // .catch((err) => );
};
